import React, { useState, useEffect } from "react";
import { StyleSheet, View, ActivityIndicator, Text } from "react-native";
import { StackActions } from "@react-navigation/native";
import BackgroundUser from "../components/BackgroundUser";
import Title from "../components/Title";
import InputLayout from "../components/InputLayout";
import Logo from "../components/Logo";
import LogoPublisher from "../components/LogoPublisher";
import ButtonLayout from "../components/ButtonLayout";
import ButtonLayoutMenu from "../components/ButtonLayoutMenu";
import Joi from "react-native-joi";
import { AsyncStorage } from "react-native";
import makeRequest from "../components/makeRequest";

export default function UserLogin(props) {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [isFailed, setFailed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userInfo, setUserInfo] = useState([]);
  useEffect(() => {
    const isAuth = async () => {
      if (await AsyncStorage.getItem("x-citaprevia-token").catch(() => false)) {
        const userInfo = await makeRequest("users/me", "get");
        if (userInfo[0] == 200 && userInfo[1].adminLevel > 0)
          props.navigation.dispatch(StackActions.replace("AdminScreen"));
        else if (userInfo[0] == 200)
          props.navigation.dispatch(StackActions.replace("UserScreen"));
        else await AsyncStorage.removeItem("x-citaprevia-token");
      }
    };
    isAuth();
  }, []);
  const testLogin = async () => {
    setLoading(true);
    let response = await makeRequest("logins", "post", {
      email: user,
      password: password,
    });
    console.log(response[1]);
    await AsyncStorage.setItem("x-citaprevia-token", response[1].token);
    if (response[0] === 200) {
      const userInfo = await makeRequest("users/me", "get");

      if (userInfo[0] == 200 && userInfo[1].adminLevel > 0)
        props.navigation.dispatch(StackActions.replace("AdminScreen"));
      else if (userInfo[0] == 200)
        props.navigation.dispatch(StackActions.replace("UserScreen"));
    } else {
      setLoading(false);
      setFailed(true);
    }
  };
  return (
    <BackgroundUser scroll={true}>
      <Logo></Logo>
      <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
        <Title style={{ fontFamily: "Montserrat-Bold" }}>Iniciar sesión</Title>
        <InputLayout
          placeholder='Correo electrónico'
          onChangeText={(text) => setUser(text.trim())}
          errorMessage='Introduzca una dirección válida'
          schema={Joi.string()
            .regex(/^\w+@.+?\.[a-zA-Z]{2,3}$/)
            .min(1)
            .max(255)
            .required()}
          value={user}></InputLayout>
        <InputLayout
          secureTextEntry={true}
          onChangeText={(text) => setPassword(text.trim())}
          value={password}
          style={isFailed ? { marginBottom: 1 } : {}}
          placeholder='Contraseña'></InputLayout>
        {isFailed && (
          <Text
            style={{
              margin: 0,
              color: "red",
              textAlign: "center",
            }}>
            Datos de inicio incorrectos
          </Text>
        )}
        <ButtonLayout text='Ingresar' onPress={() => testLogin()} />
        {
          <ActivityIndicator
            color='white'
            size='small'
            style={{ opacity: loading ? 1 : 0 }}
          />
        }

        <View style={{ justifyContent: "flex-end", marginBottom: 15 }}>
          <LogoPublisher />

          <ButtonLayoutMenu
            style={{ alignSelf: "center" }}
            text='Registro'
            onPress={() =>
              props.navigation.dispatch(StackActions.replace("UserRegister"))
            }
          />
        </View>
      </View>
    </BackgroundUser>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
